import { graphql } from 'gatsby'
import React from "react"
import { Helmet } from 'react-helmet'
import config from "../../data/config.js"
import PostListing from "../components/PostListing/PostListing.js"
import Layout from "../components/layout"


export default class AuthorTemplate extends React.Component {
    render(){
	  const category = this.props.pageContext.category
	  const data = this.props.data
	  return (
      <Layout>

	    <div>
	    <Helmet title={`Category ${category} | ${config.title}`} />
	      <h1> Posts in {category} </h1>
        <PostListing data={data.allMarkdownRemark} />

	    </div>
      </Layout>

	  )
   }
}

export const query = graphql `
  query CategoryPage($category: String) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date],  order: DESC },
      filter: { frontmatter: { categories: { eq: $category }, published: {eq: true} } },
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
	          categories
            author
            image {
              childImageSharp {
                fluid(duotone: {highlight: "#FFFFFF", shadow: "#e13327"}, maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
              publicURL
            }
          }
          fields {
            slug
          }
           excerpt(pruneLength: 300)
        }
      }
    }
  }
`
